import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=bf6c0414&"
import script from "./projectList.vue?vue&type=script&lang=js&"
export * from "./projectList.vue?vue&type=script&lang=js&"
import style0 from "../../../less/_projects_popup.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf6c0414')) {
      api.createRecord('bf6c0414', component.options)
    } else {
      api.reload('bf6c0414', component.options)
    }
    module.hot.accept("./projectList.vue?vue&type=template&id=bf6c0414&", function () {
      api.rerender('bf6c0414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/leftSideBar/includes/projectList.vue"
export default component.exports